"use strict";
$(function () {

    if (window.location.pathname !== "/tellimine-tasutud/") {
        return false;
    }

    if (location.hash) {
        let attrs = location.hash.substr(1).split('/');
        const reference_nr = attrs[0];
        const price = attrs[1];

        let confirmation_data = {
            reference_nr: reference_nr,
            price: price,
        };

        let template_data = {
            action: 'register_confirmation',
            data: confirmation_data
        };

        $.post(myAjax.ajaxurl, template_data, function(response) {
            const res = JSON.parse(response);
            if (res.status) {
                window.location.href = location.pathname;
            }
        });
    }


    //window.limiter = 90;
    window.limiter = 1;

    if(srv_id) {

        let serverReadyInterval = setInterval(function () {
            let template_data = {
                action: 'get_server_status',
                srv_id: srv_id
            };

            $.post(myAjax.ajaxurl, template_data, function(response) {
                const res = JSON.parse(response);
                if (res.status) {
                    if (res.data === "in_use") {
                        clearInterval(serverReadyInterval);
                        $('.loading').hide();
                        $('.website-creating-notice').hide();
                        $('.website-done-notice').show();
                    }
                    if (window.limiter <= 0) {
                        clearInterval(serverReadyInterval);
                        window.limiter--;
                    }
                }
            });

        }, 2000);

    }





});